export default __webpack_public_path__ + "static/nfo-wings-4c03469133071b188b09477e41e47107.png";